import * as React from 'react'
import { PageProps } from '@logic'
import { EditAccountSettingsShared } from '@modules/profile/components/edit-acc-shared'
import { signUpModal } from '@shared/components/modal'

type Props = PageProps

export const GuestEditAccountSettings = (props: Props) => {
    const { navigate } = props
    const signUpModalBundle = signUpModal({ navigate })

    return <>
        {signUpModalBundle.component}
        <EditAccountSettingsShared {...props} forGuest={true} openSignUp={() => signUpModalBundle.setVisible(true)} />
    </>

}
